/* Copyright (c) 2020-present CloudIO Inc */

import {
  BOOLEAN_OPS,
  STRING_OPS_KEY_TYPE,
  NUMBER_OPS_KEY_TYPE,
  SELECT_OPS,
  MULTIPLE_SELECT_OPS,
  STRING_OPS,
  MULTIPLE_STRING_OPS,
  DATE_OPS,
  MULTIPLE_DATE_OPS,
  NUMBER_OPS,
  MULTIPLE_NUMBER_OPS,
  DATE_OPS_KEY_TYPE,
  BOOLEAN_OPS_KEY_TYPE,
} from '@cloudio-saas/datasource-types';
import { YN_TF_OPERATORS } from 'components/SmartSearch/Operators';
import { SmartSearchAttribute } from '../SmartSearchAttribute/SmartSearchAttribute';
import { AttributeDataType } from './SmartSearch';

export type SELECT_OPS_KEY_TYPE =
  | keyof typeof SELECT_OPS
  | keyof typeof MULTIPLE_SELECT_OPS;

export type StringOperator = {
  value: keyof typeof STRING_OPS;
  label: string;
};

export type MultiStringOperator = {
  value: keyof typeof MULTIPLE_STRING_OPS;
  label: string;
};

export type DateOperator = {
  value: keyof typeof DATE_OPS;
  label: string;
};

export type MultipleDateOperator = {
  value: keyof typeof MULTIPLE_DATE_OPS;
  label: string;
};

export type NumberOperator = {
  value: keyof typeof NUMBER_OPS;
  label: string;
};

export type MultipleNumberOperator = {
  value: keyof typeof MULTIPLE_NUMBER_OPS;
  label: string;
};

export type SelectOperator = {
  value: keyof typeof SELECT_OPS;
  label: string;
};

export type MutltipleSelectOperator = {
  value: keyof typeof MULTIPLE_SELECT_OPS;
  label: string;
};

export type Operator =
  | StringOperator
  | DateOperator
  | NumberOperator
  | SelectOperator
  | MultiStringOperator
  | MultipleDateOperator
  | MultipleNumberOperator
  | MutltipleSelectOperator;

export const allDateOps = { ...DATE_OPS, ...MULTIPLE_DATE_OPS };
export const allStringOps = { ...STRING_OPS, ...MULTIPLE_STRING_OPS };
export const allNumberOps = { ...NUMBER_OPS, ...MULTIPLE_NUMBER_OPS };
export const allSelectOps = { ...SELECT_OPS, ...MULTIPLE_SELECT_OPS };
export const allBooleanOps = { ...BOOLEAN_OPS };

export const BOOLEAN_OPERATORS = (
  Object.keys(allBooleanOps) as BOOLEAN_OPS_KEY_TYPE[]
).map((key) => ({
  value: key,
  label: allBooleanOps[key],
}));

export const DATE_OPERATORS = (
  Object.keys(allDateOps) as DATE_OPS_KEY_TYPE[]
).map((key) => ({
  value: key,
  label: allDateOps[key],
}));

export const STRING_OPERATORS = (
  Object.keys(allStringOps) as STRING_OPS_KEY_TYPE[]
).map((key) => ({
  value: key,
  label: allStringOps[key],
}));

export const NUMBER_OPERATORS = (
  Object.keys(allNumberOps) as NUMBER_OPS_KEY_TYPE[]
).map((key) => ({
  value: key,
  label: allNumberOps[key],
}));

export const SELECT_OPERATORS = (
  Object.keys(allSelectOps) as SELECT_OPS_KEY_TYPE[]
).map((key) => ({
  value: key,
  label: allSelectOps[key],
}));

export const operatorsArray = {
  Text: STRING_OPERATORS,
  Number: NUMBER_OPERATORS,
  Date: DATE_OPERATORS,
  Select: SELECT_OPERATORS,
  Lookup: SELECT_OPERATORS,
  Boolean: BOOLEAN_OPERATORS,
  YN: YN_TF_OPERATORS,
  TF: YN_TF_OPERATORS,
  JSON: STRING_OPERATORS, // TODO
};
export const getOperatorsArray = (type: AttributeDataType) => {
  return operatorsArray[type] as Operator[];
};

export const getDefaultOperator = (
  smartSearchAttribute: SmartSearchAttribute,
) => {
  return smartSearchAttribute.defaultOperator;
};

export const getOperator = (type: AttributeDataType, operatorValue: string) => {
  const operatorArr = operatorsArray[type] as Operator[];
  const operator = operatorArr.find((op) => op.value === operatorValue);
  return operator;
};
